export enum RestrictionStatusInfrastructureOperatorColorEnum {
    RESTRICTION_UNKNOWN = 'medium',
    RESTRICTION_CREATED = 'maizecrayola',
    RESTRICTION_REMOVED = 'medium',
    RESTRICTION_PENDING_ACCEPTANCE = 'activated',
    RESTRICTION_PENDING_REVIEW = 'warning',
    RESTRICTION_ACCEPTED = 'success',
    RESTRICTION_APPROVED = 'zomp',
    RESTRICTION_BLOCKING = 'redsalsa',
}